// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/StepCheck.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stepper_stepper__ESlM7 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.Stepper_step__vEWZ9 {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.Stepper_main__6dkLc {
  width: 16px;
  height: 16px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  border: 2px solid #7baac3;
  font-size: 14px;
  font-weight: 600;
  color: #7baac3;
  background: #fff;
  flex: 0 0 auto;
}

.Stepper_sub__8Bvdb {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  aspect-ratio: 1/1;
  border: 1px solid #7ca6bd;
  background: #ffffff;
  flex: 0 0 auto;
}

.Stepper_active__ys4jt.Stepper_main__6dkLc {
  background: #7baac3;
  color: #fff;
  position: relative;
}
.Stepper_active__ys4jt.Stepper_main__6dkLc::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 6px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: contain;
  background-position: center center;
}

.Stepper_active__ys4jt.Stepper_sub__8Bvdb {
  background: #7baac3;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/Stepper/Stepper.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AACD;;AAEA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AACD;;AAEA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AACD;;AAEA;EACC,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AACD;;AAEA;EACC,mBAAA;EACA,WAAA;EACA,kBAAA;AACD;AACC;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,WAAA;EACA,2EAAA;EAEA,wBAAA;EACA,kCAAA;AAAF;;AAIA;EACC,mBAAA;AADD","sourcesContent":[".stepper {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n}\r\n\r\n.step {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\ttransition: all 0.3s ease;\r\n}\r\n\r\n.main {\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\taspect-ratio: 1 / 1;\r\n\tborder-radius: 50%;\r\n\tborder: 2px solid #7baac3;\r\n\tfont-size: 14px;\r\n\tfont-weight: 600;\r\n\tcolor: #7baac3;\r\n\tbackground: #fff;\r\n\tflex: 0 0 auto;\r\n}\r\n\r\n.sub {\r\n\twidth: 6px;\r\n\theight: 6px;\r\n\tborder-radius: 50%;\r\n\taspect-ratio: 1 / 1;\r\n\tborder: 1px solid #7ca6bd;\r\n\tbackground: #ffffff;\r\n\tflex: 0 0 auto;\r\n}\r\n\r\n.active.main {\r\n\tbackground: #7baac3;\r\n\tcolor: #fff;\r\n\tposition: relative;\r\n\r\n\t&::after {\r\n\t\tcontent: '';\r\n\t\tposition: absolute;\r\n\t\ttop: 50%;\r\n\t\tleft: 50%;\r\n\t\ttransform: translate(-50%, -50%);\r\n\t\twidth: 10px;\r\n\t\theight: 6px;\r\n\t\tbackground: url('../../../../public/images/StepCheck.svg') no-repeat\r\n\t\t\tcenter center;\r\n\t\tbackground-size: contain;\r\n\t\tbackground-position: center center;\r\n\t}\r\n}\r\n\r\n.active.sub {\r\n\tbackground: #7baac3;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepper": `Stepper_stepper__ESlM7`,
	"step": `Stepper_step__vEWZ9`,
	"main": `Stepper_main__6dkLc`,
	"sub": `Stepper_sub__8Bvdb`,
	"active": `Stepper_active__ys4jt`
};
export default ___CSS_LOADER_EXPORT___;
